<template>
<div class="read-article">
  <div class="content" v-if="data">
    <div class="swiper-wrapper">
      <Swipe :autoplay="3000">
        <SwipeItem v-for="(item, index) in data.urls" :key="data.id + index">
          <div
            class="img-wrapper"
            :style="{ backgroundImage: 'url(' + item + ')' }"
            @click="imagePreview(index)"
          ></div>
        </SwipeItem>
      </Swipe>
    </div>
    <div class="body-wrapper">
      <div class="desc">
        {{ data.content }}
      </div>
      <div class="goods" v-if="data.goodsId" @click="toGoodsDetail">
        <div
          class="img"
          :style="{
            backgroundImage: 'url(' + data.goodsImage + ')',
          }"
        ></div>
        <div class="text">
          <div class="title van-ellipsis">
            {{ data.goodsName }}
          </div>
          <div class="amount">
            <span class="prefix">¥</span>
            <span class="value">{{ data.actPrice }}</span>
            <!-- <span class="unline">省赚¥{{ data.saveProfit }}</span> -->
          </div>
        </div>
        <div>
          <Button type="info" size="small">立即购买</Button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { getMaterialDetail, getOfficialDetail, getGrowingDetail } from '@/api/discovery'
import { Button, Swipe, SwipeItem, ImagePreview } from 'vant'
export default {
  components: { Button, Swipe, SwipeItem },
  data() {
    return {
      customerId: this.$route.query.customerId,
      id: this.$route.query.id,
      type: this.$route.query.type, // 0 店长素材 1 官方公告 2 新人成长
      data: null
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      const type = Number(this.type)
      if (type === 0) {
        getMaterialDetail(this.id).then(res => {
          this.data = res.data
        })
      }
      if (type === 1) {
        getOfficialDetail(this.id).then(res => {
          this.data = res.data
        })
      }
      if (type === 2) {
        getGrowingDetail(this.id).then(res => {
          this.data = res.data
        })
      }
    },
    imagePreview(index) {
      ImagePreview({
        images: this.data.urls,
        startPosition: index,
        closeable: true,
      })
    },
    toGoodsDetail() {
      this.$router.push({ path: `/goodsDetail/${this.data.partGoodsId}?customerId=${this.customerId}` })
    }
  }
}
</script>

<style lang="less" scoped>
.read-article {
  text-align: left;
  .content {
    padding: 0 0 80px;
    font-size: 30px;
    .swiper-wrapper {
      width: 100%;
      height: 400px;
      .van-swipe {
        height: 100%;
      }
      .img-wrapper {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
      }
    }
    .body-wrapper {
      padding: 40px 24px;
    }
    .desc {
      padding-bottom: 20px;
    }
    .goods {
      padding: 20px 40px;
      display: flex;
      align-items: center;
      box-shadow: 0 0 30px #eee;
      border-radius: 14px;
      margin-top: 30px;
      .img {
        width: 80px;
        height: 80px;
        border-radius: 12px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
      }
      .text {
        flex: 1;
        min-width: 0;
        padding-left: 40px;
        .title {
          font-size: 26px;
          font-weight: bold;
          color: #333333;
          line-height: 40px;
        }
        .amount {
          padding-top: 8px;
          display: flex;
          align-items: flex-end;
          .prefix {
            font-size: 24px;
            line-height: 1em;
            font-weight: 800;
            color: #e82035;
          }
          .value {
            font-size: 32px;
            line-height: 1em;
            font-weight: 800;
            color: #e82035;
          }
          .unline {
            font-size: 20px;
            color: #e82035;
            line-height: 1em;
            line-height: 24px;
            margin-left: 8px;
          }
        }
      }
    }
  }
}
</style>